import Datetime from 'utils/datetime/datetime'
import type { HourInput } from '../IntradayTradingView.types'

export function buildIntradayPriceInputData(
  prices: HourInput[],
  optStartTime: ISODateTime
): { intraday_prices: { times: string[]; values: number[] } } {
  const times: string[] = []
  const values: number[] = []

  prices.forEach((price, index) => {
    const trimmedValue = price.value.trim()
    if (trimmedValue === '') {
      return
    }

    times.push(Datetime.addHours(optStartTime, index + 1))
    values.push(parseFloat(trimmedValue.replace(',', '.')))
  })

  return { intraday_prices: { times, values } }
}
